import IcCloseMenu from 'assets/Icons/Menu/IcCloseMenu';
import { ModalBackground } from 'components/Modal/ModalForms';
import { mindupAdminMobilePaths } from 'constants/path';
import React, { MouseEvent } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import styled, { keyframes } from 'styled-components';
import { BackgroundColor, PrimaryColor, TextColor } from 'styles/Global/colorSemantic';
import { Body2Bold, Caption1Regular } from 'styles/Global/typography';

const MindUpAdminMobileMenu = ({ close }: { close: () => void }) => {
    const version = require('../../../package.json').version;
    const { pathname } = useLocation();

    const handleBackgroundClick = (e: MouseEvent) => {
        if (e.target === e.currentTarget) {
            close();
        }
    };

    const handleMenuClick = (link: string) => {
        if (pathname === link) {
            close();
        }
    };

    return (
        <ModalBackground $type='mobile'>
            <Layout onClick={handleBackgroundClick}>
                <HeaderContainer>
                    <HeaderText>전체 메뉴</HeaderText>
                    <CloseButtonWrapper onClick={close}>
                        <IcCloseMenu />
                    </CloseButtonWrapper>
                </HeaderContainer>
                {menuArray.map((item, index) => (
                    <ActiveNavLink
                        key={index}
                        to={item.link}
                        onClick={(e) => {
                            handleMenuClick(item.link);
                        }}
                    >
                        {item.menu}
                    </ActiveNavLink>
                ))}
                <CopyrightArea>ⓒTLC Healthcare (v{version})</CopyrightArea>
            </Layout>
        </ModalBackground>
    );
};

export default MindUpAdminMobileMenu;

const Layout = styled.section`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 360px;
    max-width: 576px;
    height: 100%;
`;
const HeaderContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 0 0 16px;
    background-color: white;
`;

const HeaderText = styled(Body2Bold)``;

const CopyrightArea = styled(Caption1Regular)`
    width: 100%;
    height: 62px;
    padding: 28px 20px 16px 20px;
    background-color: white;
    color: rgba(153, 153, 153, 0.5);
    text-opacity: 0.5;
`;

const CloseButtonWrapper = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 100%;
`;

const ActiveNavLink = styled(NavLink)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 56px;
    padding: 0 0 0 20px;
    background-color: white;
    text-decoration: none;

    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: ${TextColor.color_text_neutral};

    &:active {
        background-color: ${BackgroundColor.color_background_normal};
    }

    &.active {
        background-color: ${BackgroundColor.color_background_primary_normal};
        font-weight: 700;
        color: ${PrimaryColor.color_primary_normal};
    }
`;

const menuArray = [
    { menu: '예약 대기 상담', link: mindupAdminMobilePaths.mindUpAdminMobileAllReservationConsultation },
    { menu: '예약된 나의 상담', link: mindupAdminMobilePaths.mindUpAdminMobileUserReservationConsultation },
    { menu: '완료된 나의 상담', link: mindupAdminMobilePaths.MindUpAdminMobileCompletedUserCounsel },
];

const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;
